import React, {Component} from 'react';
import {Redirect} from 'react-router-dom'
import {Table,message,PageHeader,Button,Modal,Form,Input,Select} from 'antd';
import reqwest from 'reqwest'
import {Header} from '../Header.jsx'
import {Footer} from '../Footer.jsx'
import {CheckLogin} from '../Common.jsx'
import { ExclamationCircleOutlined, CloseCircleOutlined} from '@ant-design/icons';
import BuildTitle from '../BuildTitle.jsx'


export class Doctors extends Component {
	constructor(props) {
	    super(props);
		let token = '';
		let user_name = '';
		let role = '';
		let check_result = CheckLogin()
		if (check_result !== false){
			token = check_result.Authorization
	    	user_name = check_result.user_name
	    	role = check_result.role;
		}
		this.state = {
			...props,
			'token' : token,
			'user_name': user_name,
			'role': role,
			'redirect' : '',
			'list' : [],
			'loading': true,
			'pagination': {
				'pageSize': 20,
				'current' : 1,
				'total' : 0,
			},

			'column' : [
				{'title':'姓名', 'dataIndex':'name_chs',width:100},
				{'title':'邮箱', 'dataIndex':'email'},
				{'title':'单位', 'dataIndex':'institution'},
				// {'title':'单位类型', 'dataIndex':'institution_type', width:160},
				{'title':'职位', 'dataIndex':'title', width:120},
				{'title':'手机号码', 'dataIndex':'mobile',width:90},
				{'title':'业务员', 'dataIndex':'sales',width:90, render:(text,record) => {
					return text.map((item,index) => {
						return <div key={item.id}>{item.name_chs} <CloseCircleOutlined className="hand" onClick={e=>{this.removeSale(record['id'],item.id)}} /></div>
					})
				}},
				{'title':'创建时间', 'dataIndex':'created_at', width:180},
				{'title':'操作', 'key':'action', width:180, render:(item,record) => {
					return (
						<div>
							<Button type="link" className="btn-in-table" onClick={() => {this.openRemoveModal(record)}}>删除</Button>
							<Button type="link" className="btn-in-table" onClick={() => {this.openEditModal(record)}}>编辑</Button>
							<Button type="link" className="btn-in-table" onClick={() => {this.openAddSale(record)}}>添加业务员</Button>
						</div>
					)
				}},
			],

			'edit_record': {},
			'sale_list': [],
		}
	}
	componentDidMount(){
		this.fetch({...this.state.pagination});
	}

	getRandomuserParams = (params) => {
		return {
			pageSize: params.pageSize,
			page: params.current,
			...params,
		};
	}

	fetch = (params) => {
		reqwest({
			url: `/api/mgm/doctors`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			data:this.getRandomuserParams(params),
			type: 'json',
		}).then(
			(data) => {

				if(data.status === 1){
					this.setState({
						'loading': false,
						'list': data.results.data,
						'pagination': {
			       			'current': params.current,
						    'pageSize': params.pageSize,
			       			'total': data.results.total,
			        	}
					})
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}

	// 表格发生改变时候
	handleTableChange = (pagination) => {
		this.setState({
			'loading': true,
		})
		this.fetch({
			current : pagination.current,
			pageSize: pagination.pageSize,
		});
	};


	openUserAddModal = () => {
		this.setState({
			'user_add_modal': true,
		})
	}
	closeUserAddModal = () => {
		this.setState({
			'user_add_modal': false,
		})
	}
	postAddUser = (data) =>{
		data['role'] = 'doctor';
		reqwest({
			url: `/api/mgm/doctor`,
			method: 'POST',
			headers: {
				'Authorization': this.state.token,
			},
			data:data,
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.setState({
						'user_add_modal':false,
						'loading': true,
					})
					this.fetch({...this.state.pagination});
				}else{
					message.error(data.msg);
				}
			},
			(err,data) => {
				message.error('Network error');
			}
		);
	}
	userAdd = () => {
		let form =this.refs.new_user;
		form.validateFields().then((data) => {
			console.log(data);
			this.postAddUser(data);
		})
	}
	

	openRemoveModal = (record) => {
		let that = this;
		Modal.confirm({
			title: '警告',
			icon: <ExclamationCircleOutlined />,
			content: '您确认删除该用户?',
			onOk() {
				reqwest({
					url: `/api/mgm/doctor`,
					method: 'DELETE',
					headers: {
						'Authorization': that.state.token,
					},
					data:{'id':record['id']},
					type: 'json',
				}).then(
					(data) => {
						if(data.status === 1){
							message.success('删除成功');
							that.fetch({...that.state.pagination});
						}else{
							message.error(data.msg);
						}
					},
					(err,data) => {
						message.error('Network error');
					}
				);
			},
		});
	}

	removeSale = (doctor_id, sale_id) => {
		let that = this;
		Modal.confirm({
			title: '警告',
			icon: <ExclamationCircleOutlined />,
			content: '您确认删除该业务员?',
			onOk() {
				reqwest({
					url: `/api/mgm/doctor/sale`,
					method: 'DELETE',
					headers: {
						'Authorization': that.state.token,
					},
					data:{'sale_id':sale_id, 'doctor_id':doctor_id },
					type: 'json',
				}).then(
					(data) => {
						if(data.status === 1){
							message.success('删除成功');
							that.fetch({...that.state.pagination});
						}else{
							message.error(data.msg);
						}
					},
					(err,data) => {
						message.error('Network error');
					}
				);
			},
		});
	}

	openEditModal = (record) => {
		this.setState({
			'user_edit_modal': true,
			'edit_record': record
		});
	}
	closeUserEditModal = () => {
		this.setState({
			'user_edit_modal': false,
			'edit_record': {}
		});
	}
	postEditUser = (data) =>{
		data['id'] = this.state.edit_record['id'];
		reqwest({
			url: `/api/mgm/doctor`,
			method: 'PUT',
			headers: {
				'Authorization': this.state.token,
			},
			data:data,
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.setState({
						'user_edit_modal':false,
						'edit_record': {},
						'loading': true,
					})
					this.fetch({...this.state.pagination});
				}else{
					message.error(data.msg);
				}
			},
			(err,data) => {
				message.error('Network error');
			}
		);
	}
	userEdit = () => {
		let form =this.refs.edit_user;
		form.validateFields().then((data) => {
			this.postEditUser(data);
		})
	}

	edit_form = (data) => {
		return (
			<Form
				style={{marginTop:'0px'}}
				ref="edit_user"
				layout="horizontal"
				initialValues={data}
				labelCol = {{ span: 4 }}
				wrapperCol = {{ span: 20 }}
				labelAlign="left"
			>
				<Form.Item name="name_chs" label="姓名" rules={[{ required: true }]} >
					<Input value="" />
				</Form.Item>
				<Form.Item name="institution" label="单位">
					<Input value="" />
				</Form.Item>
				<Form.Item name="institution_type" label="单位类型"  >
					<Select>
						<Select.Option value="医院">医院</Select.Option>
						<Select.Option value="科研机构">科研机构</Select.Option>
						<Select.Option value="公司">公司</Select.Option>
						<Select.Option value="个人">个人</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item name="title" label="职位" >
					<Input value="" />
				</Form.Item>
				<Form.Item name="mobile" label="手机号码" >
					<Input value="" />
				</Form.Item>
				<Form.Item name="tel" label="座机" >
					<Input value="" />
				</Form.Item>
			</Form>
		)
	}


	openAddSale = (record) => {
		reqwest({
			url: `/api/mgm/sales`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					this.setState({
						'sale_add_modal':true,
						'sale_list': data.results.data,
						'this_doctor': record,
					})
				}else{
					message.error(data.msg);
				}
			},
			(err,data) => {
				message.error('Network error');
			}
		);
	}

	closeAddSale = () => {
		this.setState({
			'sale_add_modal':false,
			'sale_list': [],
			'this_doctor': {},
		})
	}
	addSale = () => {
		let data = this.refs.add_sale.getFieldsValue();
		if(!data.sale_id){
			message.error('请选择一个销售');
			return false;
		}
		reqwest({
			url: `/api/mgm/doctor/sale`,
			method: 'POST',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data:{doctor_id:this.state.this_doctor['id'], 'sale_id': data.sale_id}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.fetch({...this.state.pagination});
					this.setState({
						'sale_add_modal':false,
						'sale_list': [],
						'this_doctor': {},
					})
				}else{
					message.error(data.msg);
				}
			},
			(err,data) => {
				message.error('Network error');
			}
		);
	}

	render(){
		if(! this.state.token){
			return <Redirect to="/login"/>
		}
		if(this.state.role === 'doctor'){
			return <Redirect to="/cases"/>
		}
		if(this.state.role === 'sale'){
			return <Redirect to="/tests"/>
		}
		return (
			<div>
				<Header {...this.state} L1="doctors" />
				<div className="max-width">
					<PageHeader title="医生管理" style={{padding:0,marginTop:10}} 
						extra={[
							<Button key="1" onClick={this.openUserAddModal} type="primary">添加医生</Button>,
						]}
					>
						<Table 
							bordered 
							loading={this.state.loading} 
							rowKey="id" 
							size="small" 
							columns={this.state.column} 
							dataSource={this.state.list}
							onChange={this.handleTableChange}
							pagination={{  //分页
						        total: this.state.pagination.total, //数据总数量
						        pageSize: this.state.pagination.pageSize,  //显示几条一页
						        defaultPageSize: 10, //默认显示几条一页
						        showSizeChanger: true,  //是否显示可以设置几条一页的选项
						        showTotal:  () => {return '共' + this.state.pagination.total + '条记录'; }
						    }}
						    locale={{emptyText:'No Data',}}
						/>
					</PageHeader>
				</div>
				<Modal
		        	title={<BuildTitle visible={this.state.user_add_modal} id="user_add_modal" title="添加医生" />}
					visible={this.state.user_add_modal}
					onCancel={this.closeUserAddModal}
					onOk={this.userAdd}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('user_add_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="new_user"
						layout="horizontal"
						initialValues={{}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 20 }}
						labelAlign="left"
					>
						
						<Form.Item name="email" label="邮箱" rules={[{ required: true }]} >
							<Input value="" />
						</Form.Item>
					</Form>
				</Modal>

				<Modal
		        	title={<BuildTitle visible={this.state.user_edit_modal} id="user_edit_modal" title="编辑医生信息" />}
					visible={this.state.user_edit_modal}
					onCancel={this.closeUserEditModal}
					onOk={this.userEdit}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('user_edit_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					{this.edit_form(this.state.edit_record)}	
				</Modal>

				<Modal
		        	title={<BuildTitle visible={this.state.sale_add_modal} id="sale_add_modal" title="给医生添加业务员" />}
					visible={this.state.sale_add_modal}
					onCancel={this.closeAddSale}
					onOk={this.addSale}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('sale_add_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="add_sale"
						layout="horizontal"
						initialValues={{}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 20 }}
						labelAlign="left"
					>
						<Form.Item name="sale_id" label="销售" rules={[{ required: true }]}>
							<Select
								showSearch
								placeholder="请选择一个销售"
								optionFilterProp=""
								filterOption={this.select_search}
							>
								{
									this.state.sale_list.map((item,index) => {
										return <Select.Option key={item['id']} value={item['id']}>{item['name_chs']} {item['institution']}</Select.Option>
									})
								}
							</Select>
						</Form.Item>
					</Form>
				</Modal>

				<Footer />
			</div>
		)
	}
}